<template>
  <maker-layout>
    <div>
      <priorities-list :maker="maker" :admin="canUpdatePriorities">
        <template slot="beforeList" v-if="!canUpdatePriorities">
          <v-alert dense text outlined type="info" class="text-left">
            Ce prestataire gère lui-même ces informations
          </v-alert>
        </template>
      </priorities-list>
    </div>
  </maker-layout>
</template>

<script>
import { mapState } from 'vuex';
import MakerLayout from '@/views/settings/makers/MakerLayout.vue';
import PrioritiesList from '@/views/settings/PrioritiesList.vue';

export default {
  data: () => ({
  }),
  computed: {
    ...mapState(`ui/settingsMakers`, {
      maker: `currentAdminMaker`,
    }),
    canUpdatePriorities() {
      return this.maker?.slug === ``;
    },
  },
  components: {
    MakerLayout,
    PrioritiesList,
  },
};
</script>
